import { z } from 'zod';

import { AdvisorsGroupZod } from 'types/zod/advisors-group';

export const UpdateGroupDataZod = AdvisorsGroupZod.pick({ name: true, parentGroupId: true, groupId: true }).and(
    z.object({ admins: z.array(z.number()) }).optional(),
);
export type UpdateGroupData = z.infer<typeof UpdateGroupDataZod>;
